import { isSuccess } from '@orus.eu/result'

import { createLoginRedirect } from './build-login-href.ts'
import { resetLoginBounce } from './detect-login-redirect-loop.ts'
import type { SessionGuardOptions } from './session-access.ts'

export async function requireCustomerSession({ context, location, preload }: SessionGuardOptions): Promise<void> {
  const sessionResult = await context.session.getSessionResult()

  if (!isSuccess(sessionResult)) return

  const session = sessionResult.output
  if (!session.user || session.permissions.type !== 'client') {
    throw createLoginRedirect(location.href, preload)
  }

  if (!preload) {
    resetLoginBounce()
  }
}
